// src/index.js
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

// React 17 style render
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);